interface IconBadgeProps {
  badgeContent: number | string;
  children: React.ReactNode;
}

const IconBadge = (props: IconBadgeProps) => {
  const {
    children,
    badgeContent,
  } = props;
  return (
    <div className="relative">
      {badgeContent !== 0 && (
        <div className={`
          absolute right-0 top-0 flex size-4
          translate-x-[65%] translate-y-[-65%] items-center
          justify-center rounded-full bg-accent-3 text-1
          text-gray-12
        `}
        >
          {badgeContent}
        </div>
      )}
      {children}
    </div>
  );
};

export { IconBadge };
